import { UPDATE_TEXT_ALERT_PHONE_NUMBER_DETAILS } from 'constants/ActionTypes';
import React from 'lib/react';
import { useDispatch, useSelector } from 'lib/redux';
import {
  EVGrid, EVInputLabel,
} from 'lib/components';
import SelectField from 'commonComponents/select-field';
import TextInputField from 'commonComponents/textInputField';
import MaskedPhoneNumber from 'commonComponents/maskedPhoneNumber';
import { useTranslation } from 'lib/translation';
import Typography from 'commonComponents/typography';
import TextAlertSettingsStyles from '../TextAlertSettingsStyles';
import { getTextAlertValues, getMobileProvidersList } from '../TextAlertSettings.utils';

function TextAlertPhoneDetails() {
  const dispatch = useDispatch();
  const classes = TextAlertSettingsStyles();
  const { t } = useTranslation();
  const handleMobileProviderChange = (event) => {
    const { target: { name, id, value } } = event;
    const targetId = id || name;
    dispatch({ type: UPDATE_TEXT_ALERT_PHONE_NUMBER_DETAILS, targetId, value });
  };

  const {
    textAlertPreferences, mobileProviders, updatedTextAlertPreferences,
  } = useSelector(({ textAlertSettings }) => textAlertSettings);
  const mobileProvidersList = getMobileProvidersList(mobileProviders);

  const mobileProviderId = getTextAlertValues(updatedTextAlertPreferences, textAlertPreferences, 'mobileProviderId');
  const mobileNumber = getTextAlertValues(updatedTextAlertPreferences, textAlertPreferences, 'mobileNumber');

  return (
    <EVGrid className={classes.textAlertPhoneContainer}>
      <Typography fontColor="charcoal-800">
        {t('text_alert_settings__alert_settings_edit_or_sign_up')}
      </Typography>
      <EVGrid className={classes.phoneInputContainer}>
        <EVGrid className={classes.fieldContainer} item>
          <EVInputLabel
            className={classes.inputLabel}
          >
            {t('text_alert_settings__select_your_phone_provider')}
          </EVInputLabel>
          <SelectField
            selectId="mobileProviderId"
            name="mobileProviderId"
            variant="outlined"
            fullWidth
            selectedValue={mobileProviderId}
            handleChange={handleMobileProviderChange}
            descriptionKey="name"
            className={classes.mobileProvidersSelectField}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
              PaperProps: {
                className: classes.paper,
              },
            }}
            selectOptions={mobileProvidersList}
          />
        </EVGrid>
        <EVGrid className={classes.fieldContainer} item>
          <TextInputField
            inputId="mobileNumber"
            inputValue={mobileNumber}
            size="small"
            inputLabelProps={{
              className: classes.inputLabel,
            }}
            handleChange={handleMobileProviderChange}
            inputFieldProps={{
              fullWidth: true,
              inputProps: { maxLength: 12 },
              classes: { root: classes.phoneInputText },
            }}
            labelText={t('text_alert_settings__enter_mobile_number')}
            InputProps={{
              inputComponent: MaskedPhoneNumber,
            }}
          />
        </EVGrid>
      </EVGrid>
    </EVGrid>
  );
}

export default TextAlertPhoneDetails;
